import React from "react";

import styles from "./OfferForm.module.css";
import {Button, ButtonState} from "../../../../elements/button/Button";
import {RootState} from "../../../../../app/store";
import {ValidatedForm} from "../../../../elements/validator/validatedForm/ValidatedForm";
import {FormHeader} from "../../../../elements/formHeader/FormHeader";
import {
    CreateOfferRequest,
    Currency,
    OfferSource,
    OfferStatus,
    OfferType,
    UpdateOfferRequest,
    UpdateSubtractionRequest
} from "../../../../../api/generated";
import {GeneralOfferInformation} from "./components/GeneralOfferInformation";
import {SpecificOfferInformation} from "./components/SpecificOfferInformation";

export type OfferRequest = CreateOfferRequest | UpdateOfferRequest
export type OfferRequestPartial = Partial<OfferRequest>

export type OfferFormSelectionProvider = {
    publicId(state: RootState): string | undefined;
    publicBotId(state: RootState): string | undefined;
    publicLocationId(state: RootState): string | undefined;
    offerStatus(state: RootState): OfferStatus | undefined;
    archivedAt(state: RootState): string | undefined;
    offerType(state: RootState): OfferType | undefined;
    offerSource(state: RootState): OfferSource | undefined;
    offerSourceName(state: RootState): string | undefined;
    title(state: RootState): string | undefined;
    description(state: RootState): string | undefined;
    make(state: RootState): string | undefined;
    model(state: RootState): string | undefined;
    startDate(state: RootState): string | undefined;
    endDate(state: RootState): string | undefined;
    redirectUrl(state: RootState): string | undefined;
    imageUrl(state: RootState): string | undefined;
    discount(state: RootState): UpdateSubtractionRequest | undefined
    currency(state: RootState): Currency | undefined;
    financeProduct(state: RootState): string | undefined;
    cashPrice(state: RootState): number | undefined;
    monthlyPayments(state: RootState): number | undefined;
    customerDeposit(state: RootState): number | undefined;
    manufacturerDepositContribution(state: RootState): number | undefined;
    totalDeposit(state: RootState): number | undefined;
    dealerContribution(state: RootState): number | undefined;
    balanceToFinance(state: RootState): number | undefined;
    totalAmountPayable(state: RootState): number | undefined;
    totalChargeForCredit(state: RootState): number | undefined;
    optionalFinalPayment(state: RootState): number | undefined;
    durationOfAgreementInMonths(state: RootState): number | undefined;
    apr(state: RootState): number | undefined;
    fixedInterestRate(state: RootState): number | undefined;
    mileagePerAnnum(state: RootState): number | undefined;
    excessMileageCharge(state: RootState): number | undefined;
};


interface Props {
    formTitle: string
    onClose: () => any;
    onSubmit: () => any;
    updateRequest: (update: OfferRequestPartial) => void;
    selectionProvider: OfferFormSelectionProvider;
}

export const OfferForm = <T extends OfferRequest>({
                                                      formTitle,
                                                      onClose,
                                                      onSubmit,
                                                      updateRequest,
                                                      selectionProvider
                                                  }: Props) => {

    return <ValidatedForm<T> submitForm={onSubmit}>
        {(formCtx) => {
            const {formDisabled, onSubmitClick, updateValidationStatus, getMessage} = formCtx;
            return <div className={styles.wrapper}>
                <FormHeader
                    formTitle={formTitle}
                    onClose={onClose}
                />
                <div className={styles.fieldsWrapper}>
                    <GeneralOfferInformation
                        getMessage={getMessage}
                        updateRequest={updateRequest}
                        selectionProvider={selectionProvider}
                        updateValidationStatus={updateValidationStatus}
                    />
                    <SpecificOfferInformation
                        getMessage={getMessage}
                        updateRequest={updateRequest}
                        selectionProvider={selectionProvider}
                        updateValidationStatus={updateValidationStatus}
                    />
                </div>
                <div className={styles.buttonsWrapper}>
                    <Button
                        title={"Close"}
                        state={ButtonState.SECONDARY}
                        handleClick={() => onClose()}
                    />
                    <Button
                        title={formTitle}
                        state={formDisabled ? ButtonState.DISABLED : ButtonState.PRIMARY}
                        handleClick={() => onSubmitClick()}
                    />
                </div>
            </div>
        }}
    </ValidatedForm>
}



